<template>
  <div class="steps_sect flex-row">
    <template v-for="stepIndex in totalSteps">
      <div
        :key="`step_${stepIndex}`"
        :class="['step', {active: stepIndex === activeStep}]"
      >
        {{ stepIndex }}
      </div>

      <div
        v-if="stepIndex < totalSteps"
        :key="`space_${stepIndex}`"
        class="horiz_line"
      ></div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ReadOnlyStepperHeader',
  props: {
    totalSteps: {
      type: Number,
      default: 0
    },
    activeStep: {
      type: Number,
      default: 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/header/ReadOnlyStepperHeader.vue